// Mandatory confidentiality marking applied to every export (CONTRACTS §10).
// These strings are FIXED — the footer is stamped on every printed PDF page and
// the label on every PNG/SVG export. Do not vary them per doc (the product
// decision is a single "Confidential" marking for all internal material).

export const CONFIDENTIAL_FOOTER =
  "© 2026 Loop Data, Inc. DBA CelleryⓇ All Rights Reserved. Confidential & Proprietary. For Internal Discussion Purposes Only.";

export const CONFIDENTIAL_LABEL = "CONFIDENTIAL";
